import { Component, Input, OnInit } from '@angular/core';
import { EvaluationTaskStatusEnum } from 'projects/admin/src/app/features/evaluation-tasks/models/enums/EvaluationTaskStatusEnum';
import { StatusTask } from 'projects/admin/src/app/features/evaluation-tasks/models/ListData';

@Component({
  selector: 'app-evaluation-task-status',
  standalone: false,
  templateUrl: './evaluation-task-status.component.html'
})
export class EvaluationTaskStatusComponent implements OnInit {
  @Input({ required: true }) status: StatusTask;
  evaluationTaskStatus = EvaluationTaskStatusEnum;

  constructor() { }

  ngOnInit() {
  }

}
